export default __webpack_public_path__ + "static/media/install-mock.0b009e54.png";